import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledTextarea = styled.textarea`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  background-color: ${(props) => props.backgroundColor};
  border: 1px solid transparent;
  border-color: ${(props) => (props.isInvalid ? '#FA339D' : '')};
  border-radius: 5px;
  letter-spacing: 1px;
  padding: 5px 10px;
  font-size: 12px;
  text-align: ${(props) => props.textAlign};
  color: ${(props) => props.textColor};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : '')};
  ${(props) => !props.resizable && 'resize: none;'}

  &.type-of-line {
    border-radius: 0;
    background: transparent;
    border: none;
    border-bottom: 1px solid ${(props) => props.lineColor};
  }

  &:disabled {
    opacity: 0.3;
  }

  &:focus {
    outline: none;
    border-color: ${(props) => (props.isInvalid ? '#FA339D' : '#2dd1ff')};
  }

  ::placeholder {
    color: rgb(10, 74, 154, 0.5);
    font-size: 12px;
    visibility: ${(props) => (props.disabled ? 'hidden' : 'visibile')};
  }
`;

const Textarea = ({ placeholder, onChange: propOnChange, ...restProps }) => {
  function onChange(e) {
    propOnChange(e);
  }

  return <StyledTextarea type="text" placeholder={placeholder} onChange={onChange} {...restProps} />;
};

Textarea.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};

Textarea.defaultProps = {
  width: '100%',
  height: '5rem',
  placeholder: '',
  onChange: () => {},
  backgroundColor: 'rgb(10, 74, 154, 0.1);',
  lineColor: '#FFFFFF',
  textAlign: 'start',
  textColor: 'rgba(0, 0, 0, 1)',
  resizable: false,
};

export default Textarea;
